<template>
  <div class="s_loading" v-show="visible">
    <img src="~assets/images/common/loading.svg" alt="">
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false
    };
  }
};
</script>
<style lang="scss" scoped>
.s_loading {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.1);
  img {
    position: absolute;
    width: 1.267rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// loading.vue?1e7b6cf0